<template>
    <div>
        <h2 class="text-center" style="font-weight: bold;">Smartby (SBY)</h2>
        <div class="text-center px-4 pb-2" style="font-size: 1.1rem;">
            {{ $t(`Bem-vindo à dashboard do token Smartby. Aqui, você pode acompanhar todas as métricas importantes
            do nosso token, incluindo suprimento total, taxa de transação e muito mais. Esta
            plataforma oferece uma visão completa e transparente do desempenho e da distribuição do Smartby Coin,
            ajudando você a tomar decisões informadas.`)
            }}
        </div>
        <div v-if="loading" class="text-center">
            {{ $t('Carregando...') }}
        </div>
        <div v-else>
            <h3>{{ $t('Geral') }}</h3>
            <hr>
            <b-row>
                <b-col cols="12" md="6" lg="4">
                    <statistic-card-horizontal icon="TagIcon" color="success" :statistic="tokenData.name"
                        :statistic-title="$t('Nome')" />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <statistic-card-horizontal icon="TagIcon" color="primary" :statistic="tokenData.symbol"
                        :statistic-title="$t('Símbolo')" />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <statistic-card-horizontal icon="PackageIcon" color="danger"
                        :statistic="(tokenData.totalSupply).toLocaleString('en-US')"
                        :statistic-title="$t('Quantidade total de tokens')" />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <statistic-card-horizontal icon="DollarSignIcon" color="danger"
                        :statistic="moneyFormatFiat(tokenData.price)" :statistic-title="$t('Preço atual')" />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <statistic-card-horizontal icon="DollarSignIcon" color="danger"
                        :statistic="moneyFormatFiat(tokenData.totalSupply * tokenData.price)"
                        :statistic-title="$t('Valor de mercado')" />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <statistic-card-horizontal icon="TrendingDownIcon" color="dark"
                        :statistic="(tokenData.totalBurned).toLocaleString('en-US')"
                        :statistic-title="$t('Total de tokens queimados')" />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <statistic-card-horizontal icon="PieChartIcon" color="secondary"
                        :statistic="`${tokenData.currentTaxBuy}%`"
                        :statistic-title="$t('Imposto atual sobre compra')" />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <statistic-card-horizontal icon="PieChartIcon" color="secondary"
                        :statistic="`${tokenData.currentTaxSell}%`"
                        :statistic-title="$t('Imposto atual sobre venda')" />
                </b-col>
                <b-col cols="12">
                    <b-card :title="$t('Contrato')">
                        <h5>{{ tokenData.contractAddress }}</h5>
                    </b-card>
                </b-col>
            </b-row>
            <h3>{{ $t('Meus tokens Smartby') }}</h3>
            <hr>
            <b-row>
                <b-col cols="12" md="6" lg="6">
                    <statistic-card-horizontal icon="PackageIcon" color="success"
                        :statistic="(tokenData.balanceOf).toLocaleString('en-US')"
                        :statistic-title="$t('Meus tokens Smartby')" />
                </b-col>
                <b-col cols="12" md="6" lg="6">
                    <statistic-card-horizontal icon="DollarSignIcon" color="info"
                        :statistic="moneyFormatFiat(tokenData.balanceOf * tokenData.price)"
                        :statistic-title="$t('Valor dos meus tokens')" />
                </b-col>
            </b-row>          
        </div>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BTable,
    BAlert,
    BProgress
} from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";

export default {
    name: 'GoldenCoinDashboard',
    components: {
        BRow,
        BCol,
        BCard,
        BTable,
        StatisticCardHorizontal,
        BAlert,
        BProgress
    },
    data() {
        return {
            loading: true,
            tokenData: {},
            supplyGrowthData: [
                { threshold: '>= 1,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 2,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 4,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 6,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 8,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 10,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 12,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 14,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 16,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '>= 18,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
                { threshold: '== 21,000,000', mintRate1: '', mintRate2: '', mintRate3: '' },
            ],
            supplyGrowthFields: [
                { key: 'threshold', label: this.$t('Limite de fornecimento') },
                { key: 'mintRate1', label: this.$t('Rendimento diário') },
                { key: 'mintRate2', label: this.$t('Rendimento mensal') },
                { key: 'mintRate3', label: this.$t('Rendimento anual') }
            ],
            holdersData: [
                { address: '', amount: '', value: '' },
            ],
            holdersFields: [
                { key: 'address', label: this.$t('Endereço') },
                { key: 'amount', label: this.$t('Quantidade') },
                { key: 'value', label: this.$t('Valor') },
            ],
            loadingHolders: false,
            limitHolders: 0,
            amountCollected: null,
            holdersCount: null
        };
    },
    mounted() {
        this.getInfoToken();
        this.mintRate();
    },
    methods: {
        mintRate() {
            const rates = [480, 432, 384, 336, 288, 240, 192, 144, 96, 48, 0];
            for (let i = 0; i < rates.length; i++) {
                this.supplyGrowthData[i].mintRate1 = '~' + (((rates[i] / 100000) * 100) * 1).toFixed(2) + '%';
                this.supplyGrowthData[i].mintRate2 = '~' + (((rates[i] / 100000) * 100) * 30).toFixed(2) + '%';
                this.supplyGrowthData[i].mintRate3 = '~' + (((rates[i] / 100000) * 100) * 365).toFixed(2) + '%';
            }
        },
        getInfoToken() {
            this.loading = true;
            this.$store.dispatch('getInfoToken')
                .then(response => {
                    this.tokenData = response;
                    this.loading = false;
                    this.getHolders();
                    this.getAdmGoldenCoinBalance();
                }).catch(error => {
                    this.loading = false;
                });
        },
        getHolders() {
            this.loadingHolders = true;
            this.limitHolders += 20;
            const data = [];
            this.$store.dispatch('getHolders', this.limitHolders)
                .then(response => {
                    response.holders.map(item => {
                        data.push({ address: this.abbreviateAddress(item.address), amount: parseFloat(item.balance).toLocaleString('en-US'), value: this.moneyFormatFiat(parseFloat(item.balance) * this.tokenData.price) })
                    })
                    this.holdersCount = response.holdersCount;
                    this.holdersData = data;
                    this.loadingHolders = false;
                }).catch(error => {
                    this.loadingHolders = false;
                });
        },
        getAdmGoldenCoinBalance() {
            this.$store.dispatch('getAdmGoldenCoinBalance')
                .then(response => {
                    const total = 500000;
                    this.amountCollected = (total - response) * 0.1;
                }).catch(error => {
                    this.loadingHolders = false;
                });
        },
        moneyFormatFiat(value) {
            // Função para formatar valores monetários
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
        },
        abbreviateAddress(address) {
            if (!address || address.length < 10) {
                return address; // Return the original address if it's too short to abbreviate
            }
            const start = address.substring(0, 6);
            const end = address.substring(address.length - 4);
            return `${start}...${end}`;
        }
    }
};
</script>

<style scoped>
.progress-container {
  width: 100%;
  height: 20px;
  /* Definir uma altura fixa para o contêiner */
  position: relative;
  /* Posição relativa para o contêiner */
  background-color: #111D2A;
  border-radius: 4px;
}

.progress-bar {
  height: 20px;
  position: absolute;
  /* Posição absoluta para a barra de progresso */
  background-color: #4A6CF7;
  border-radius: 4px;
  transition: width 0.5s;
  /* Efeito de animação */
}

.progress-label {
  color: white;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
}
</style>